interface WidInterface {
  mp: number
  sae: number
}

interface AidInterface {
  mp: string
  sae: string
}

const getWid = (
  isMpCrossSell: boolean,
  wid: WidInterface | string | number
) => {
  if (typeof wid === 'string') {
    wid = JSON.parse(wid)
  }
  if (typeof wid === 'object') {
    return Number(isMpCrossSell ? wid.mp : wid.sae)
  }
  return Number(wid)
}

const getAid = (isMpCrossSell: boolean, aid: AidInterface | string) => {
  if (typeof aid === 'object') {
    return isMpCrossSell ? aid.mp : aid.sae
  }
  return aid
}

export { getWid, getAid }
